interface PaginationButtonProps {
  className?: string
  onClick: () => void
  children: React.ReactNode
}

export default function PaginationButton({
  className,
  onClick,
  children,
}: PaginationButtonProps) {
  return (
    <button
      className={`pagination__btn ${className ? className : ""}`}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
